import { render, staticRenderFns } from "./FileLanguages.vue?vue&type=template&id=052c7004"
import script from "./FileLanguages.vue?vue&type=script&lang=js"
export * from "./FileLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports